module.exports = __webpack_public_path__ + "img/call.7e4cb5d9.png";